/* eslint-disable @typescript-eslint/member-ordering */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import {map} from 'rxjs/operators';
import { Playroom } from '../models/playroom.model';

@Injectable({
  providedIn: 'root'
})

export class PlayroomService {

  apiUrl = environment.apiUrl;
  private playroomsSource = new ReplaySubject<any>(1);
  playrooms$ = this.playroomsSource.asObservable();

  constructor(private http: HttpClient) { }

  addPlayroom(room: Playroom) {
    const workingHoursFrom = `2001-01-01T${room.workingHoursFrom}:00.0000000`;
    const workingHoursTo = `2001-01-01T${room.workingHoursTo}:00.0000000`;
    return this.http.post(this.apiUrl + 'room', {...room, workingHoursFrom, workingHoursTo});
  }

  getAllPlayrooms() {
    return this.http.get(this.apiUrl + 'room').pipe(map((rooms) => {
      if(rooms) {
        this.playroomsSource.next(rooms);
      }
    })).toPromise();
  }

  getAllPlayroomsSub(): Observable<Playroom[]> {
  return this.http.get<Playroom[]>(this.apiUrl + 'room');
}

  editPlayroom(room) {
    const workingHoursFrom = `2001-01-01T${room.workingHoursFrom}:00`;
    const workingHoursTo = `2001-01-01T${room.workingHoursTo}:00`;
    return this.http.put(`${this.apiUrl}room/${room.id}`,  {...room, workingHoursFrom, workingHoursTo});
  }

  deletePlayroom(id) {
    return this.http.delete(`${this.apiUrl}room/${id}`);
  }

}
